<template>
    <div>
        <Header />
        <div class="termcondition-main-container">
            <div class="container">
                <div class="termcondition-title-header">
                    <div class="termcondition-title">
                        Terms & Conditions
                    </div>
                    <div class="termcondition-back-btn">
                        <router-link to="/">
                        Home
                        </router-link>
                    </div>
                </div>
                <div class="termcondition-body">
                   <div class="row">
                       <div class="col-lg-12">
                            <h4>Terms & Conditions</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> Any use of this website or its contents, including copying or storing it or them in whole or part, other than for your own personal, non-commercial use is prohibited without the explicit permission of TMBill. All information displayed, transmitted or carried on TMBill is protected by copyright and other intellectual property laws. All rights, including copyright, in this website are owned by or licensed to TMBill. This site is designed, updated and maintained independently by TMBill.</p>
                            <p><i class="fa fa-chevron-right"></i> The content is owned by TMBill. Without TMBill Permission Merchant Cannot modify, publish, transmit, transfer, sell, reproduce, create derivative work from, distribute, repost, perform, display or in any way commercially exploit any of the content available in the website.</p>
                            
                            <hr>
                            <h4>Ownership of rights</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> Any use of this website or its contents, including copying or storing it or them in whole or part, other than for your own personal, non-commercial use is prohibited without the explicit permission of TMBill. All information displayed, transmitted or carried on TMBill is protected by copyright and other intellectual property laws. All rights, including copyright, in this website are owned by or licensed to TMBill. This site is designed, updated and maintained independently by TMBill.</p>
                            <p><i class="fa fa-chevron-right"></i> The content is owned by TMBill. . Without TMBill Permission Merchant Cannot modify, publish, transmit, transfer, sell, reproduce, create derivative work from, distribute, repost, perform, display or in any way commercially exploit any of the content available in the website.</p>
                            
                            <hr>
                            <h4>Disclaimer</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> Information, services, names, pictures, advertisements, images and contents are provided “as is” on this web site. Tech Mainstay Private Limited expressly disclaims all and any kind of warranties, whether express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. Parties using the information provided on this web site may do so after satisfying themselves that the same suits their individual requirements.TMBill uses information voluntarily provided by users to optimise their experience on our web site, whether to provide personalised elements on the site, or to prepare a better future content base in the interests of our users. However, the information contained on this web site is not intended to be, and should not be treated as legal or professional advice. “TMBill” is a registered trademark. All other trademarks, company names or logos, and product names referred to in this web site remain the property of their respective owners.In no event shall TMBill be responsible to any person or entity for any loss or damage, whether direct, indirect, incidental, consequential or otherwise, arising out of access or use or dissemination of information contained on this web site, including, but not limited to, loss of profits, data, or damage to the user’s computer systems. The information, contents, names, images, etc. may be changed, updated, modified and/or improved from time to time without any notice.This Disclaimer Clause and any claims arising out of the use of the information from this web site shall be governed by the laws of India andonly the Courts in Delhi, and no other Courts, shall have jurisdiction over the same. By accessing this web site, the user accepts this.</p>
                            
                            <hr>
                            <h4>Communication</h4>
                            <hr>
                            <p><i class="fa fa-chevron-right"></i> When you visit the Website or send emails to us, you are communicating with us electronically. You consent to receive communications from us electronically. We will communicate with you by email or by posting notices on the Website. You agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.</p>
                       </div>
                   </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>


<script>
import Header from "./Header"
import Footer from './Footer';

import { mapGetters, mapActions } from 'vuex';

import $ from 'jquery';
export default {
    name:"termsandcondition",
    components: {
       Header,
       Footer
    },
    computed:{
         ...mapGetters(['outletInformation']),
         
    },
    methods: {
        ...mapActions(["getMenuItems"]),
    },
    created() {
        this.getMenuItems();

        this.$nextTick( function () {
    
      // $("#divTest").scrollTop($("#divTest")[0].scrollHeight);


       $(window).scrollTop(0);
    })
    }

}
</script>